module.exports = __webpack_public_path__ + "static/media/forest2.da6a2d59.jpg";